import React from 'react';
import PropTypes from 'prop-types';
import logger from '@utils/logger';
import Article from '../pages/Article';
import { getRevalidateTime } from './revalidate-time';
import { convertArticles, fetchContent, withNavigation, pruneRelated } from './contentfulHelpers';
import { findHubName } from './hubs';

const generateArticlePage = (articleType) => {
  const propTypes = {
    content: PropTypes.arrayOf(
      PropTypes.shape({
        body: PropTypes.shape({}),
      }),
    ),
    articleId: PropTypes.string.isRequired,
  };

  const defaultProps = {
    content: [],
  };

  const ArticlePageComponent = ({ content, articleId }) => {
    const [item] = content;
    return (
      <Article
        type={articleType === 'writing-by-jk-rowling' ? 'jkrOriginal' : 'article'}
        article={item.body}
        externalId={articleId}
      />
    );
  };
  ArticlePageComponent.propTypes = propTypes;
  ArticlePageComponent.defaultProps = defaultProps;

  async function getStaticProps(context) {
    const { articleId } = context.params;

    if (!articleId) {
      return { notFound: true, revalidate: Number(process.env.REVALIDATION_TIMEOUT_SHORT) };
    }

    const contentTypes =
      articleType === 'writing-by-jk-rowling' ? ['writingByJKRowling'] : ['article'];

    const variables = {
      contentTypes,
      externalId: articleId,
    };

    const [content, errors] = await fetchContent(variables);
    const location = `Page: /${articleType}/${articleId}`;
    logger(location, content, errors);
    if (
      !content ||
      !content.length ||
      findHubName(content?.[0]?.body?.tags ?? []) !== articleType
    ) {
      return { notFound: true, revalidate: Number(process.env.REVALIDATION_TIMEOUT_SHORT) };
    }

    if (errors) {
      if (errors.statusCode === 404) {
        return { notFound: true, revalidate: Number(process.env.REVALIDATION_TIMEOUT_SHORT) };
      }
      throw new Error(errors.statusMessage);
    }

    const convertedArticles = convertArticles(content);
    // eslint-disable-next-line no-underscore-dangle
    const revalidate = getRevalidateTime(convertedArticles[0].body._updatedAt);
    convertedArticles[0].body.relatedArticleReference = pruneRelated(
      convertedArticles[0].body.relatedArticleReference,
    );
    const props = await withNavigation({ content: convertedArticles });

    return {
      props: {
        ...props,
        articleType,
        articleId,
      },
      revalidate,
    };
  }

  async function getStaticPaths() {
    return {
      fallback: 'blocking',
      paths: [],
    };
  }

  return {
    ArticlePageComponent,
    getStaticProps,
    getStaticPaths,
  };
};

export default generateArticlePage;
